<template>
  <div
    class="wrap"
    :class="{ 'pay-wrap-active': namespaceGroupEn === 'weixinjinke' }"
  >
    <template v-if="!pageImage">
      <div class="title" :class="namespaceGroupEn" v-if="headerName">
        {{ headerName }}
      </div>
      <img :src="pageConfig.display_img_url" alt="" class="header" />
      <img :src="pageConfig.icon_img_url" alt="" class="content" />
    </template>
    <template v-if="pageImage">
      <van-image :src="pageImage" />
    </template>
    <div class="service" @click="serviceCenter">
      <svg-icon :iconClass="icon" />客服中心
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  defineComponent,
  onMounted,
  computed,
  ref,
} from "@vue/composition-api";

import { jsonSafeParse } from "@/utils";
import { getIndexCategory } from "@/apis/product";
import { useStore } from "@/components/use/base";

const vm = Vue.prototype;

export default defineComponent({
  setup() {
    const store = useStore();

    const pageConfig = ref({});
    const packageMap = ref({});
    const pageImage = ref("");

    const namespace = computed(() => store.state.namespace);

    const namespaceGroupEn = computed(() => {
      return store.state.namespaceInfo?.namespace_group_en || "";
    });

    const icon = computed(() => {
      return packageMap.value[namespace.value]?.server || "";
    });

    const headerName = computed(() => {
      return packageMap.value[namespace.value]?.headerName || "";
    });

    onMounted(() => {
      pageImage.value = jsonSafeParse(vm.$getConfigValue("BJ_VISITOR_PAGE"))[
        namespace.value
      ];
      packageMap.value = jsonSafeParse(vm.$getConfigValue("BJ_CARD_MAP"));
      const pageData = packageMap.value[namespace.value];
      if (!pageImage.value) initPage(pageData);
    });

    const initPage = async (pageData) => {
      if (pageImage.value) return;
      const { data } = await getIndexCategory({
        namespace: pageData.page,
        opened_page: "visitor",
        source: "default",
      });
      pageConfig.value = data?.[0];
    };

    const serviceCenter = () => {
      window.location.href =
        "https://oakvip.s2.udesk.cn/im_client/?web_plugin_id=62106";
    };

    return {
      pageConfig,
      icon,
      headerName,
      pageImage,
      namespaceGroupEn,
      serviceCenter,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  position: relative;
  height: 100%;
  padding-bottom: 40px;
}

.title {
  position: absolute;
  font-size: 24px;
  left: 49px;
  top: 85px;
  color: #dfc8b4;

  &.lianrong {
    font-family: "YouSheBiaoTiHei-2";
  }
}

.header {
  width: 100%;
  margin: 0;
  display: block;
  height: 100%;
}

.content {
  width: 100%;
  height: 100%;
  display: block;
}

.service {
  margin: 0 auto;
  margin-top: 32px;
  width: 343px;
  height: 32px;
  background: #ffffff;
  border-radius: 8px;
  bottom: 33px;
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #333333;
  line-height: 21px;

  svg {
    height: 20px;
    width: 22px;
    margin-right: 9px;
  }
}

.pay-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 94px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.07);

  .pay-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 343px;
    height: 48px;
    border-radius: 32px;
    margin: 0 auto;
    margin-top: 14px;
    background: url("https://common-h5-dev.xiangshuheika.com/static/upload/20250814b10e1804eca1f.png")
      no-repeat center center;
    background-size: 100% 100%;
  }
  .pay-btn-price {
    color: #fff;
    font-size: 32px;
    font-weight: 500;
    width: 75px;
    text-align: center;

    span {
      font-size: 14px;
      margin-right: 4px;
    }
  }

  .pay-btn-text {
    color: rgb(109, 68, 21);
    font-size: 18px;
    font-weight: 400;
  }
}
</style>
